import React from "react"
import styled from "styled-components"
import { white } from "./colors"
import { VERSION } from '../index'

const Version = styled.div`
  position: absolute;
  text-transform: uppercase;
  bottom: 0;
  color: ${white};
  opacity: 0.3;
  font-size: 14px;
  user-select: none;
  pointer-events: none;
`

export const VersionInfo: React.FC = () => {
  return <Version className="insert-app-version">{`V${VERSION}`}</Version>
}
